import type { GetEnvironmentDataResponse } from '@src/gen/ai/h2o/cloud/appstore/v1/ai.h2o.cloud.appstore';

/** Flag id → state, exactly as the environment response carries it. */
export type EnvironmentFeatureFlags = Readonly<Record<string, boolean>>;

/**
 * The one place the generated type is corrected. The proto field is
 * `map<string, bool>`, which protojson serializes as a JSON object — but the
 * twirp TS generator types every proto map as a `{key, value}[]` entry list,
 * so the generated `featureFlags` type does not match the value actually on
 * the wire. The generated client returns `res.json()` untransformed, so the
 * runtime value is the object; this accessor gives it its real type.
 *
 * `undefined` while the environment has not resolved — callers treat that as
 * loading, never as "all closed".
 */
export const getEnvironmentFeatureFlags = (
  env: GetEnvironmentDataResponse | undefined
): EnvironmentFeatureFlags | undefined => env?.featureFlags as unknown as EnvironmentFeatureFlags | undefined;

/** Builds the generated wire type from the real shape, for mocks and specs. */
export const asWireFeatureFlags = (flags: EnvironmentFeatureFlags): GetEnvironmentDataResponse['featureFlags'] =>
  flags as unknown as GetEnvironmentDataResponse['featureFlags'];
